export { default } from "ember-file-upload/services/file-queue";
